/* eslint-disable i18next/no-literal-string */
import React from 'react';
import { Button } from 'react-bootstrap';
import titleImage from 'assets/images/gen-ai-image-landing/title.png';
import { ReactComponent as StarIcon } from 'assets/images/gen-ai-image-landing/star.svg';
import hero1 from 'assets/images/gen-ai-image-landing/hero/1.png';
import hero2 from 'assets/images/gen-ai-image-landing/hero/2.png';
import hero3 from 'assets/images/gen-ai-image-landing/hero/3.png';
import hero4 from 'assets/images/gen-ai-image-landing/hero/4.png';
import hero5 from 'assets/images/gen-ai-image-landing/hero/5.png';
import hero6 from 'assets/images/gen-ai-image-landing/hero/6.png';
import { useHistory } from 'react-router-dom';
import styles from './Hero.module.scss';

export default function Hero() {
  const history = useHistory();
  return (
    <>
      <div className={styles.hero}>
        <div className={styles.content}>
          <div className={styles.line1}>
            We&apos;re here
          </div>

          <div className={styles.line2}>
            to build your
            {' '}
            <img
              src={titleImage}
              alt="Dream Room"
              className={styles.titleImage}
            />
            {' '}
            dream room
          </div>

          <div className={styles.line3}>
            in just 1 click
          </div>

          <div className={styles.decorativeSection}>
            <div className={styles.horizontalLine} />
            <div className={styles.verticalLine} />

            <div className={styles.decorativeStar}>
              <StarIcon />
            </div>

            <Button
              className={styles.ctaButton}
              onClick={() => {
                history.push('/get-started');
              }}
            >
              Free Sign Up Now
            </Button>
          </div>
        </div>
      </div>

      <div className={styles.carouselSection}>
        <div className={styles.carouselContainer}>
          <div className={styles.carouselTrack}>
            <img src={hero1} alt="Interior Design 1" className={styles.carouselImage} />
            <img src={hero2} alt="Interior Design 2" className={styles.carouselImage} />
            <img src={hero3} alt="Interior Design 3" className={styles.carouselImage} />
            <img src={hero4} alt="Interior Design 4" className={styles.carouselImage} />
            <img src={hero5} alt="Interior Design 5" className={styles.carouselImage} />
            <img src={hero6} alt="Interior Design 6" className={styles.carouselImage} />
            {/* Duplicate images for seamless infinite scroll */}
            <img src={hero1} alt="Interior Design 1" className={styles.carouselImage} />
            <img src={hero2} alt="Interior Design 2" className={styles.carouselImage} />
            <img src={hero3} alt="Interior Design 3" className={styles.carouselImage} />
            <img src={hero4} alt="Interior Design 4" className={styles.carouselImage} />
            <img src={hero5} alt="Interior Design 5" className={styles.carouselImage} />
            <img src={hero6} alt="Interior Design 6" className={styles.carouselImage} />
          </div>
        </div>
      </div>
    </>
  );
}
